import get from '../../utils/http-utils'

export function getErrorNames() {
    return get("/Optix/lookup/errorname")
        .then(resp => {
            const errors = Object.values(resp.data).reduce((acc, val, ind) => {
                let tempObj = { key: val, value: val }
                acc.push(tempObj)
                return acc;
            }, [])
            return { data: errors }

        }, err => {
            return { error: err.message };
        })
}